import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useAuth } from "../components/AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { getRouteCategory, mobileMenu, getTestTypeValueFromUrl } from "../utils";
import { ListGroupItem } from "./ListGroupItem";

const MobileMenu = () => {
  const [menu, setMenu] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const auth = useAuth();
  const location = useLocation();
  const phlebotomy = localStorage.getItem("is_phlebotomist");
  const testType = localStorage.getItem("test_type");
  const renderLogoutButton =
    auth.isAuthenticated || JSON.parse(localStorage.getItem("isLoggedIn"));
  // Effect to set menu items based on the phlebotomy flag
  useEffect(() => {
    setIsLoading(true);
    if (
      auth.isAuthenticated ||
      JSON.parse(localStorage.getItem("isLoggedIn"))
    ) {
      if (auth.isHcpLive && phlebotomy === "true") {
        // Create a deep copy of the mobile HCP menu
        const currentMenu = mobileMenu?.mobile_hcp_menu;
        
        // Update the Boots appointment URL with current test type
        const bootsMenuItem = currentMenu.find(item => item.category === "appointment-booking");
        if (bootsMenuItem) {
          const currentTestType = getTestTypeValueFromUrl(testType);
          bootsMenuItem.to = `/bloods/boots/${currentTestType}`;
        }
        
        setMenu(currentMenu);
      } else {
        setMenu(mobileMenu?.mobile_neo_menu);
      }
    } else {
      setMenu(null); // Clear the menu on logout
    }
    setIsLoading(false);
  }, [
    auth,
    JSON.parse(localStorage?.getItem("isLoggedIn")),
    testType,
    auth?.toast,
    phlebotomy,
    auth.isHcpLive
  ]);
  return (
    <Nav className={renderLogoutButton && 'bottom-sidebar'}>
      {menu?.map(m => (
        <ListGroupItem
          key={m.to}
          to={m.to}
          active={m.category === getRouteCategory(location.pathname)}
          icon={m.icon}
          title={m.name}
          isMobile={true}
          isLoading={isLoading}
          renderLogoutButton={renderLogoutButton}
          menu={menu}
        />
      ))}
    </Nav>
  );
};

export default MobileMenu;
